import { useMemo } from "react";
import { cn } from "@/lib/utils";
import twConfig from "tailwindcss/defaultConfig";

export const Card = (props: {
  className?: string;
  children: React.ReactNode;
}) => {
  const spacing = useMemo(() => {
    if (!props.className) return null;
    const match = props.className.match(/(?:px|py|p)-(\d+)/);
    return match ? match[1] : null;
  }, [props.className]);
  return (
    <div
      className={cn(
        "relative z-10 h-full w-full max-w-6xl",
        "flex flex-col gap-4 p-12 rounded-sm",
        "bg-white/80 backdrop-blur-sm shadow-lg shadow-gray-400/10 border border-border/80",
        spacing && `[--card-spacing:theme(spacing.${spacing})]`,
        props.className,
      )}
      style={
        {
          "--card-spacing":
            spacing && spacing && typeof twConfig.theme?.spacing === "object"
              ? twConfig.theme.spacing[spacing]
              : "3rem",
        } as React.CSSProperties
      }
    >
      {props.children}
    </div>
  );
};
export const CardTitle = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn("font-medium ~text-lg/2xl", props.className)}>
      {props.children}
    </div>
  );
};

export const CardHeader = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "flex flex-row items-center justify-start gap-5 text-left",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};

export const CardHeaderDivider = (props: {
  orientation?: "horizontal" | "vertical";
  className?: string;
}) => {
  const { orientation = "horizontal", className } = props;

  return (
    <div
      className={cn(
        "relative bg-border",
        orientation === "horizontal" && "min-w-5 w-full h-px",
        orientation === "vertical" && "min-h-5 h-full w-px",
        className,
      )}
    />
  );
};

export const CardContent = (
  props: {
    children: React.ReactNode;
    className?: string;
  } & React.HTMLProps<HTMLDivElement>,
) => {
  const { children, ...rest } = props;
  return <div {...rest}> {children} </div>;
};

export const CardFooter = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn(props.className)}>{props.children}</div>;
};
